import { GQLProductFragment, GQLProductTileFragment, GQLProductVariantFragment } from '@theprintbar/graphql';
import { getSortedStockedVariantsByColour, getSortedVariantsByColour, getStockedColour } from '.';

export interface VariantItem {
	variantId: string;
	quantity: number;
}

export interface VariantAndStatus {
	variant: GQLProductVariantFragment;
	stocked: boolean;
	sameday: boolean;
}

export function getVariantIdColour(product: GQLProductFragment, variantId: string) {
	const variant = product.variants?.find(variant => variant.id === variantId);
	return product.colours?.find(c => c.id === variant?.colour.id)?.colour || null;
}

export function getVariantColour(product: Pick<GQLProductTileFragment, 'colours'>, variant: { colour: { id: string } } | null | undefined) {
	return product.colours?.find(c => c.id === variant?.colour.id)?.colour || null;
}

export function getProductColourFromVariant(
	product: Pick<GQLProductTileFragment, 'colours'>,
	variant: { colour: { id: string } } | null | undefined,
) {
	return product.colours?.find(c => c.id === variant?.colour.id) || null;
}

export function getDefaultVariant(product: GQLProductFragment, variantId?: string) {
	const variant = product.variants?.find(variant => variant.id === variantId);

	if (!variant) {
		return getSortedVariantsByColour(product, product.colours?.[0].colour.code)[0].variant;
	}

	const stockedColour = getStockedColour(product, getVariantColour(product, variant)?.code);
	if (!stockedColour) return null;

	const variants = getSortedStockedVariantsByColour(product, stockedColour.colour.code);
	return (
		variants.find(item => item.variant.size.code === variant?.size.code)?.variant ||
		variants[0]?.variant ||
		getSortedVariantsByColour(product, stockedColour.colour.code)[0].variant
	);
}

export function getVariantId(product: GQLProductFragment, productColourId: string, sizeCode: string) {
	const variant = product.variants?.find(variant => variant.colour.id === productColourId && variant.size.code === sizeCode);
	return variant?.id;
}

export function getAllSizeVariantsMatchingColourOfVariant(product: GQLProductFragment, variantId?: string) {
	const reference = product.variants?.find(variant => variant.id === variantId);
	if (!reference) return [];

	return getSortedVariantsByColour(product, getVariantColour(product, reference)?.code);
}

export function ensureVariantItemsInProduct(product: GQLProductFragment, variantItems: VariantItem[]) {
	if (!variantItems.every(item => product.variants?.some(variant => variant.id === item.variantId))) {
		throw new Error('Not all variants are in product');
	}
}
